import { getStateList } from "../services/country/country.api";
import { CustomerInfo } from "../types/userInfo";
import { CANADA_STATES, US_STATES } from "../utils/common/constants";

export const formatUserInfo = (userInfo: string) => {
  const parsedInfo = JSON.parse(userInfo);
  const hasAdlCustomer =
    parsedInfo?.adlCustomer && Object.keys(parsedInfo.adlCustomer).length > 0;
  const customerSource = hasAdlCustomer
    ? parsedInfo.adlCustomer
    : parsedInfo.lastCustomerAccessed || {};

  const countryValue = customerSource.country || "";
  const countryCode = countryValue === "US" ? "001" : "002";
  const countryName = countryValue === "US" ? "United States" : "Canada";
  const stateProvinceCode = customerSource.stateProvince || "";

  const stateList = countryValue == "US" ? US_STATES : CANADA_STATES ;
  const defaultState = { id: 0, label: "", countryID:0};
  const selectedState =
    stateList?.find((state) => stateProvinceCode === state.value) ||
    defaultState;

  const customerInfo: CustomerInfo = {
    userName : parsedInfo.userName || "",
    userID : parsedInfo.userId || "",
    firstName: parsedInfo.firstName || "",
    lastName: parsedInfo.lastName || "",
    sourceEmail: parsedInfo?.userEmail || "",
    userPhoneNumber: parsedInfo?.phoneNumber || "",
    customerAccountName: customerSource.customerName || "",
    customerAccountNumber: customerSource.customerNumber || "",
    companyCode: customerSource.companyCode || "",
    customerEmail: customerSource.email || "",
    customerPhone: customerSource.phoneNumber || "",
    addressLine1: customerSource.address1 || "",
    addressLine2: customerSource.address2 || "",
    addressLine3: customerSource.address3 || "",
    city: customerSource.city || "",
    stateID: selectedState?.id || 0,
    state: selectedState?.label || "",
    countryID: selectedState?.countryID || 0,
    country: countryName,
    countryCode: countryCode,
    postalCode: customerSource.postalCode || "",
  };
  return customerInfo;
};
